
      var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGift = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.09 2.457c.61-.585 1.614-.608 2.257-.07l.078.07 1.953 1.869a.545.545 0 0 1-.702.832l-.053-.044-1.952-1.869a.63.63 0 0 0-.827 0c-.14.134-.154.31-.042.452l.042.046.617.59a.545.545 0 0 1-.702.833l-.053-.045-.616-.59a1.413 1.413 0 0 1 0-2.074Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.57 2.456c.638-.608 1.701-.608 2.34 0 .58.554.605 1.422.072 2.002l-.073.074-.618.59a.545.545 0 0 1-.8-.74l.047-.05.619-.59c.155-.148.155-.348 0-.496-.2-.19-.557-.205-.781-.044l-.054.044-1.945 1.855a.545.545 0 0 1-.8-.74l.047-.05L9.57 2.456Z",
  fill: "#000"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 4.182c.28 0 .51.21.542.481l.004.064v8.727a.545.545 0 0 1-1.087.064l-.004-.064V4.727c0-.301.244-.545.546-.545Z",
  fill: "#000"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.454 4.182c.301 0 .546.244.546.546v2.726a.546.546 0 0 1-.546.546H2.546A.546.546 0 0 1 2 7.454V4.728c0-.302.245-.546.546-.546h10.908ZM3.091 5.272V6.91h9.818V5.272H3.091Z",
  fill: "#000"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.908 6.908c.301 0 .546.245.546.546v6a.546.546 0 0 1-.546.545H3.091a.546.546 0 0 1-.546-.545v-6c0-.301.245-.546.546-.546h9.817ZM3.636 8v4.91h8.727v-4.91H3.636Z",
  fill: "#000"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\">\r\n  <path d=\"M4.08971 2.4573C4.70082 1.87198 5.70399 1.84856 6.34681 2.38694L6.42523 2.45716L8.37755 4.32573C8.59518 4.53402 8.60274 4.8793 8.39445 5.09693C8.20218 5.29782 7.89318 5.31972 7.67561 5.15807L7.62324 5.11383L5.67094 3.24529C5.45588 3.03947 5.05902 3.03947 4.84398 3.24543C4.7044 3.37891 4.69045 3.55505 4.80225 3.69719L4.84418 3.74321L5.46057 4.33323C5.67819 4.54154 5.68574 4.88682 5.47743 5.10444C5.28514 5.30531 4.97615 5.32719 4.75859 5.16553L4.70622 5.12129L4.09003 4.53146C3.48567 3.95353 3.48567 3.03492 4.08971 2.4573Z\" fill=\"black\"/>\r\n  <path d=\"M9.56952 2.45649C10.2078 1.84786 11.2715 1.84786 11.9091 2.45634C12.4906 3.01031 12.5148 3.87808 11.982 4.45804L11.9093 4.532L11.2906 5.12203C11.0726 5.32993 10.7274 5.32175 10.5195 5.10375C10.3275 4.90251 10.3198 4.59284 10.4912 4.38287L10.5377 4.33258L11.1566 3.74236C11.3121 3.59419 11.3121 3.39434 11.1563 3.24587C10.9565 3.05517 10.5997 3.0405 10.3755 3.20198L10.3223 3.24603L8.37693 5.10088C8.15891 5.30876 7.81364 5.30053 7.60576 5.08251C7.41387 4.88125 7.40612 4.57158 7.57755 4.36163L7.62413 4.31134L9.56952 2.45649Z\" fill=\"black\"/>\r\n  <path d=\"M8.00053 4.18164C8.28026 4.18164 8.51081 4.39221 8.54232 4.66348L8.54599 4.72709V13.4543C8.54599 13.7556 8.30178 13.9998 8.00053 13.9998C7.7208 13.9998 7.49026 13.7892 7.45875 13.518L7.45508 13.4543V4.72709C7.45508 4.42585 7.69929 4.18164 8.00053 4.18164Z\" fill=\"black\"/>\r\n  <path d=\"M13.4541 4.18164C13.7553 4.18164 14 4.42629 14 4.72754V7.4541C14 7.75535 13.7553 8 13.4541 8H2.5459C2.24465 8 2 7.75535 2 7.4541V4.72754C2 4.42629 2.24465 4.18164 2.5459 4.18164H13.4541ZM3.09082 5.27246V6.90918H12.9092V5.27246H3.09082Z\" fill=\"black\"/>\r\n  <path d=\"M12.9082 6.9082C13.2094 6.9082 13.4541 7.15286 13.4541 7.4541V13.4541C13.4539 13.7551 13.2093 13.999 12.9082 13.999H3.09082C2.78973 13.999 2.54517 13.7551 2.54492 13.4541V7.4541C2.54492 7.15286 2.78957 6.9082 3.09082 6.9082H12.9082ZM3.63574 7.99902V12.9082H12.3633V7.99902H3.63574Z\" fill=\"black\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/gift.5a862e31a86d0d7edf1b863ec288db8e.svg"),
        {
          React: SvgGift,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      